import React, { useCallback, useState, createContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import NavBar from './NavBar';
import TopBar from './TopBar';
import Footer from './Footer';
import { useStyles } from './styles';
import CustomTabBar from '../../components/nav/CustomTabBar';
import { usePreferences } from '../../hooks/preferences';

export const DrawerStateContext = createContext({
  isDrawerOpen: false,
});

const Dashboard: React.FC = ({ children }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const location = useLocation();
  const { dataType, disabledTypes } = usePreferences();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [showTab, setShowTab] = useState(true);

  const handleDrawer = useCallback(() => {
    setIsDrawerOpen(!isDrawerOpen);
  }, [isDrawerOpen]);

  const handleOnClose = (): void => {
    setIsDrawerOpen(false);
  };

  useEffect(() => {
    if (location.pathname === '/dashboard') {
      setShowTab(false);
    } else {
      setShowTab(true);
    }
  }, [location]);

  return (
    <DrawerStateContext.Provider value={{ isDrawerOpen }}>
      <div className={classes.root}>
        <TopBar handleDrawer={handleDrawer} />
        <NavBar
          onCloseDrawer={() => handleOnClose()}
          drawerVisible={isDrawerOpen}
        />
        <div className={classes.content}>
          {showTab && (
            <CustomTabBar
              initialValue={dataType}
              data={[
                { value: 'roads', label: t('components:nav.roads') },
                { value: 'trucks', label: t('components:nav.trucks') },
                { value: 'drills', label: t('components:nav.drills') },
              ]}
              disabled={disabledTypes}
            />
          )}
          {children}
        </div>
        <Footer />
      </div>
    </DrawerStateContext.Provider>
  );
};

export default Dashboard;
